import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Location, PopStateEvent } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';

declare var gtag: (...args: any[]) => void;

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    public isCollapsed = true;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];

    public whatsappUrl: string;

    constructor(public location: Location, private router: Router, private deviceService: DeviceDetectorService) {
        const phoneNumber = '+5541996635645';
        const message = encodeURIComponent('Olá! Tive um problema em minha viagem e preciso da ajuda de vocês ✈️🚌');
        const base = this.deviceService.isMobile() ? 'https://api.whatsapp.com/send' : 'https://web.whatsapp.com/send';
        this.whatsappUrl = `${base}?phone=${phoneNumber}&text=${message}`;
    }

    ngOnInit() {
      this.router.events.subscribe((event) => {
        this.isCollapsed = true;
        if (event instanceof NavigationStart) {
           if (event.url != this.lastPoppedUrl)
               this.yScrollStack.push(window.scrollY);
       } else if (event instanceof NavigationEnd) {
           if (event.url == this.lastPoppedUrl) {
               this.lastPoppedUrl = undefined;
               window.scrollTo(0, this.yScrollStack.pop());
           } else
               window.scrollTo(0, 0);
       }
     });
     this.location.subscribe((ev:PopStateEvent) => {
         this.lastPoppedUrl = ev.url;
     });
    }

    // Dispara em qualquer página do site — os links continuam abrindo
    // o WhatsApp normalmente (target="_blank"), o evento só reporta a
    // conversão em paralelo, sem interceptar a navegação.
    whatsappClick() {
        gtag('event', 'conversion', {
            'send_to': 'AW-10808804687/LhHpCLHZ9e8cEM-KhaIo',
            'value': 1.0,
            'currency': 'BRL'
        });
    }

    isHome() {
        var titlee = this.location.prepareExternalUrl(this.location.path());

        if( titlee === '/home' ) {
            return true;
        }
        else {
            return false;
        }
    }
    isDocumentation() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if( titlee === '/documentation' ) {
            return true;
        }
        else {
            return false;
        }
    }
}
